<!-- Start Mensaje de error - requeridos -->
<small *ngIf="(invalidValue(form, fcn) && getLength(form, fcn) == 0)"
    class="text-base font-semibold text-red opacity-70">
    {{msj}}
</small>

<!-- Start Mensaje de error - minLength y maxLength -->
<small
    *ngIf="(invalidValue(form, fcn) && getLength(form, fcn) > 0) && (min > getLength(form, fcn) || max < getLength(form, fcn)) "
    class="text-base font-semibold text-red opacity-70">
    Debe ingresar mínimo {{min}} y máximo {{max}} caracteres.
</small>

<!-- Start Mensaje de error - email -->
<small *ngIf="(invalidValue(form, fcn) && getLength(form, fcn) > 0) && (type === 'email' )"
    class="text-base font-semibold text-red opacity-70">
    Por favor, ingresa un email en el formato correcto (ejemplo@ejemplo.com)
</small>